<ngx-spinner name="sp" [fullScreen]="false" type="square-jelly-box" size="medium" color="orange"></ngx-spinner>

<ngx-spinner name="load" size="medium" color="#f58634" type="ball-spin-clockwise"></ngx-spinner>

<router-outlet></router-outlet>
